import { AxiosInstance } from 'axios';
import * as FileSaver from 'file-saver';

const saveFile = (res: any, format: string, ext: string, fileName = 'TAP-FEED-AGENT') => {
  const blob = new Blob([res.data], { type: format });
  FileSaver.saveAs(blob, `${fileName}.${ext}`);
};

interface Props {
  HTTPTmr: AxiosInstance;
}

const GatewayServiceFactory = ({ HTTPTmr }: Props) => {
  return {
    getGateway: (format, ext): Promise<void> => {
      return HTTPTmr.get(`system/agent`, {
        responseType: 'arraybuffer',
      }).then((res) => {
        const text = res.headers['content-disposition'];
        const startIndex = text.indexOf('filename=') + 10;
        const endIndex = text.lastIndexOf('.');
        const fileName = text.substring(startIndex, endIndex);

        if (fileName) {
          return saveFile(res, format, ext, fileName);
        } else {
          return saveFile(res, format, ext);
        }
      });
    },
  };
};

export default GatewayServiceFactory;
